import React, { useState } from 'react';
import { Phone as PhoneIcon, MapPin, StarIcon, XIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-127" data-mp="3ufa5cad2jbnw">
      <div className="bg-white rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-128" data-mp="387drhtbj3d5">
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-129" data-mp="3qcx9qes1cu4u">
          <h2 className="text-xl font-serif text-brand-brown" data-id="element-130" data-mp="29zgkbzgigqll">{title}</h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-brand-brown transition-colors" aria-label="Cerrar" data-id="element-131" data-mp="2a1jkvdfai24k">
            <XIcon className="w-5 h-5" data-id="element-132" data-mp="3la27gozaktsl" />
          </button>
        </div>
        <div className="p-6 text-sm text-gray-600 space-y-4 leading-relaxed" data-id="element-133" data-mp="3gbingu49ds2v">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <>
      <footer className="bg-brand-dark text-white py-12 border-t border-brand-gold/15" data-id="element-134" data-mp="81fppw8pas47">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135" data-mp="335trjf5jnhj">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-136" data-mp="htd236bg3q4i">
            {/* Logo Image */}
            <div className="flex-shrink-0 flex flex-col items-center gap-4" data-id="element-137" data-mp="cus29803v8gl">
              <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-20 w-auto object-contain mix-blend-lighten" data-id="element-138" data-mp="qt067zvk7a19" />
              {/* Social Icons */}
              <div className="flex items-center gap-4" data-id="element-139" data-mp="yu7ictvibtz9">
                <a href="https://www.facebook.com/katherine.ospino.95063" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Facebook" data-id="element-140" data-mp="yupjo4x10ye1">
                  <FacebookIcon className="w-5 h-5" data-id="element-141" data-mp="1cnoy03l2omk0" />
                </a>
                <a href="https://www.instagram.com/tairu.aesthetics/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold-light transition-colors" aria-label="Instagram" data-id="element-142" data-mp="1hje5qu78x9re">
                  <InstagramIcon className="w-5 h-5" data-id="element-143" data-mp="3oczo179lsb4g" />
                </a>
              </div>
              {/* Google Reviews Button */}
              <a href="https://share.google/aeNeaqJ9AadTchr2e" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-xs font-medium text-brand-gold-light hover:text-brand-gold transition-colors border border-brand-gold/30 px-3 py-1.5 rounded-sm" data-id="element-144" data-mp="2aevf3w32tu7d">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-145" data-mp="1wpa0exwb8155" />
                {t('footer.reviews')}
              </a>

              {/* Accepted Payment Methods */}
              <div className="flex flex-col items-center gap-2 pt-2" data-id="element-146" data-mp="2pc4i5n1qsmex">
                <p className="text-[10px] text-gray-500 uppercase tracking-widest" data-id="element-147" data-mp="2kd1eo71euo92">
                  {t('footer.payments')}
                </p>
                <div className="flex items-center gap-3" data-id="element-148" data-mp="2fdf27ztepc1b">
                  {/* Visa */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Visa" data-id="element-149" data-mp="18z5x6rn1a3eo">
                    <rect width="48" height="32" rx="4" fill="#1A1F71" data-id="element-150" data-mp="2rvzm7cez23t6" />
                    <text x="24" y="20" textAnchor="middle" fill="#FFFFFF" fontSize="14" fontWeight="bold" fontFamily="Arial, sans-serif" fontStyle="italic" data-id="element-151" data-mp="2rtmva9r8kj3z">
                      VISA
                    </text>
                  </svg>
                  {/* Mastercard */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Mastercard" data-id="element-152" data-mp="3fk0rmcgut44d">
                    <rect width="48" height="32" rx="4" fill="#2D2D2D" data-id="element-153" data-mp="36k43cbydm79u" />
                    <circle cx="19" cy="16" r="9" fill="#EB001B" data-id="element-154" data-mp="1q6doca5pxylf" />
                    <circle cx="29" cy="16" r="9" fill="#F79E1B" data-id="element-155" data-mp="1q52kybg6qsuu" />
                    <path d="M24 9.17a9 9 0 0 1 0 13.66 9 9 0 0 1 0-13.66z" fill="#FF5F00" data-id="element-156" data-mp="1v5qk5kekig05" />
                  </svg>
                  {/* American Express */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="American Express" data-id="element-157" data-mp="1imcua155lmkv">
                    <rect width="48" height="32" rx="4" fill="#006FCF" data-id="element-158" data-mp="1rom4sr0f9fy9" />
                    <text x="24" y="14" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-159" data-mp="13xp1u3qltsz5">
                      AMERICAN
                    </text>
                    <text x="24" y="22" textAnchor="middle" fill="#FFFFFF" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-160" data-mp="18uyppeychwkv">
                      EXPRESS
                    </text>
                  </svg>
                  {/* Discover */}
                  <svg viewBox="0 0 48 32" className="h-7 w-auto" aria-label="Discover" data-id="element-161" data-mp="2q0ozx3wd9njx">
                    <rect width="48" height="32" rx="4" fill="#FFFFFF" stroke="#E5E7EB" strokeWidth="0.5" data-id="element-162" data-mp="2v1mbuyqs9lcz" />
                    <text x="24" y="14" textAnchor="middle" fill="#231F20" fontSize="6.5" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-163" data-mp="278w28w6cre5v">
                      DISCOVER
                    </text>
                    <circle cx="24" cy="22" r="5" fill="#F47216" data-id="element-164" data-mp="1b3vrd1edis8s" />
                  </svg>
                </div>
              </div>
            </div>

            {/* Info */}
            <div className="text-center md:text-right text-sm text-gray-400 space-y-2" data-id="element-165" data-mp="1744uqh261hwc">
              <p className="font-serif text-brand-gold-light text-lg mb-2" data-id="element-166" data-mp="128xtrh0a6rb4">
                {t('footer.tagline')}
              </p>
              <p className="flex items-center justify-center gap-2" data-id="element-167" data-mp="scmeci5e9lcg">
                Phenix Salon Suite (#114), 100 Broadway, Elmwood Park, NJ 07407
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2" data-id="element-168" data-mp="nfw3c98g5fxw">
                <PhoneIcon className="w-4 h-4 text-brand-gold-light" data-id="element-169" data-mp="jcg8nifxtpnu" />
                <a href="tel:5513328938" className="hover:text-brand-gold-light transition-colors" data-id="element-170" data-mp="ee4wh126732g">
                  (551) 332-8938
                </a>
              </p>

              {/* Privacy & Terms */}
              <div className="flex items-center justify-center md:justify-end gap-4 pt-3" data-id="element-171" data-mp="1hls3giq0yg8z">
                <button onClick={() => setPrivacyOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-172" data-mp="1mkvc0d57r4lp">
                  {t('footer.privacy')}
                </button>
                <span className="text-gray-600 text-xs" data-id="element-173" data-mp="1csp948dfb2rq">|</span>
                <button onClick={() => setTermsOpen(true)} className="text-xs text-gray-500 hover:text-brand-gold-light transition-colors underline underline-offset-2" data-id="element-174" data-mp="yuhiei6zcxp0">
                  {t('footer.terms')}
                </button>
              </div>

              <p className="pt-4 text-xs opacity-60" data-id="element-175" data-mp="twpq3n2fb9ka">
                © {new Date().getFullYear()} TAIRU AESTHETICS.{' '}
                {t('footer.rights')}
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <PolicyModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-176" data-mp="cm2c57n3zkv8">
        <p data-id="element-177" data-mp="7plm27wcmwfi">
          <strong data-id="element-178" data-mp="7lxrr6j2y5zq">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-179" data-mp="me80m7e5jk5o">
          En Tairu Aesthetics, respetamos su privacidad y nos comprometemos a
          proteger su información personal. Esta política describe cómo
          recopilamos, usamos y protegemos sus datos.
        </p>
        <p data-id="element-180" data-mp="vf67cxfz65ry">
          <strong data-id="element-181" data-mp="qea32irpohm0">Información que recopilamos:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-182" data-mp="qe0cou2r88fs">
          <li data-id="element-183" data-mp="15c2izc16780q">
            Nombre, número de teléfono y correo electrónico proporcionados al
            agendar citas.
          </li>
          <li data-id="element-184" data-mp="10dr58q7r8dd8">
            Información sobre su historial de tratamientos y condiciones de la
            piel.
          </li>
          <li data-id="element-185" data-mp="37506csc6h8ea">
            Datos de navegación recopilados automáticamente (cookies, dirección
            IP).
          </li>
        </ul>
        <p data-id="element-186" data-mp="iuruhj29myyq">
          <strong data-id="element-187" data-mp="iv9xcyjfobfm">Uso de la información:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-188" data-mp="dv5ej1v1z4m8">
          <li data-id="element-189" data-mp="duciovxmtziv">Programar y gestionar sus citas.</li>
          <li data-id="element-190" data-mp="8w2nilbwqyx9">Personalizar su experiencia de tratamiento.</li>
          <li data-id="element-191" data-mp="8wkmvqtv9t9e">
            Enviar recordatorios y comunicaciones relacionadas con sus
            servicios.
          </li>
        </ul>
        <p data-id="element-192" data-mp="11kq9kj4hdsbv">
          <strong data-id="element-193" data-mp="11l9ijac5l6dr">Protección de datos:</strong> Implementamos medidas de
          seguridad técnicas y organizativas para proteger su información
          personal contra acceso no autorizado, pérdida o alteración.
        </p>
        <p data-id="element-194" data-mp="rtvfiskztofv">
          <strong data-id="element-195" data-mp="rtc4zwxoa2bv">Sus derechos:</strong> Usted tiene derecho a acceder, corregir
          o eliminar su información personal en cualquier momento contactándonos
          al (551) 332-8938.
        </p>
        <p data-id="element-196" data-mp="1kcsit9esm6c3">
          No vendemos ni compartimos su información personal con terceros para
          fines de marketing.
        </p>
      </PolicyModal>

      {/* Terms Modal */}
      <PolicyModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-197" data-mp="1nu6su3oxi1q0">
        <p data-id="element-198" data-mp="1rwtetnyx4sfa">
          <strong data-id="element-199" data-mp="1rwjxeorxvtl7">Última actualización:</strong> Mayo 2026
        </p>
        <p data-id="element-200" data-mp="1ws8sofwxeobp">
          Al utilizar los servicios de Tairu Aesthetics, usted acepta los
          siguientes términos y condiciones:
        </p>
        <p data-id="element-201" data-mp="26s9cs42md8gy">
          <strong data-id="element-202" data-mp="26sj6o2qsbzrx">Citas y Cancelaciones:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-203" data-mp="26pwx5xkc3a72">
          <li data-id="element-204" data-mp="2astcnfekuq6s">
            Las citas deben ser agendadas con anticipación llamando al (551)
            332-8938.
          </li>
          <li data-id="element-205" data-mp="2fkuqv6vb2qzg">
            Solicitamos un aviso de al menos 24 horas para cancelaciones o
            reprogramaciones.
          </li>
          <li data-id="element-206" data-mp="2pihd6eexpktg">
            Las cancelaciones tardías o ausencias pueden estar sujetas a un
            cargo.
          </li>
        </ul>
        <p data-id="element-207" data-mp="2uin8q5obrrgt">
          <strong data-id="element-208" data-mp="2uidh6dnmtc90">Servicios:</strong>
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-209" data-mp="24tg5a342nu3w">
          <li data-id="element-210" data-mp="24u821h9enxvr">
            Todos los tratamientos comienzan con una evaluación personalizada de
            la piel.
          </li>
          <li data-id="element-211" data-mp="1zsinhrmz522x">
            Los resultados pueden variar según el tipo de piel y la condición
            individual.
          </li>
          <li data-id="element-212" data-mp="29rzss7ybddyd">
            Kate se reserva el derecho de recomendar o declinar tratamientos
            basándose en su evaluación profesional.
          </li>
        </ul>
        <p data-id="element-213" data-mp="2nlr4nmzip9x9">
          <strong data-id="element-214" data-mp="2ikux8zfyj5n3">Responsabilidad:</strong> Tairu Aesthetics no se hace
          responsable por reacciones adversas que resulten de la omisión de
          información médica relevante por parte del cliente.
        </p>
        <p data-id="element-215" data-mp="2sir95tgpy4m9">
          <strong data-id="element-216" data-mp="2sk2e3wlwhiey">Propiedad intelectual:</strong> Todo el contenido de este
          sitio web, incluyendo imágenes, textos y diseño, es propiedad de Tairu
          Aesthetics y está protegido por las leyes de derechos de autor.
        </p>
        <p data-id="element-217" data-mp="y72t1nyr3w0a">
          Para preguntas sobre estos términos, contáctenos al (551) 332-8938.
        </p>
      </PolicyModal>
    </>;
}